import { Typography } from '@navi/web-ui/lib/primitives';
import styles from '../EnachCard.module.scss';
import { ENACHStatus } from './const';
import ClockFilledIcon from '@navi/web-ui/lib/icons/ClockIcon';

const AutopayInProgress = () => {
  return (
    <>
      <div className={styles.enachCardErrorIcon}>
        <ClockFilledIcon color={'var(--yellow-base)'} />
      </div>
      <div className={styles.enachCardFailureReason}>
        <Typography
          variant="p3"
          color={'var(--yellow-base)'}
          className={styles.enachFailureReasonText}
        >
          {ENACHStatus.AutopayInProgress}
        </Typography>
      </div>
    </>
  );
};

export default AutopayInProgress;
